'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import { getEmptyImage } from 'react-dnd-html5-backend';
/**
 * High Order Component adding an empty image for the default drag preview. Allows us to add a custom drag layer.
 * @see {@link https://github.com/gaearon/react-dnd/blob/0f1b5d8731caeacad5474e09976b963d7462e796/examples/02%20Drag%20Around/Custom%20Drag%20Layer/DraggableBox.js}
 */

export default function withHideDefaultDragPreview() {
  return WrappedComponent => {
    class HideDefaultDragPreviewDecorator extends Component {
      componentDidMount() {
        this.props.connectDragPreview(getEmptyImage(), {
          captureDraggingState: true
        });
      }

      render() {
        return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, this.props));
      }

    }
    /*
     * Statics
     */


    HideDefaultDragPreviewDecorator.propTypes = {
      connectDragPreview: PropTypes.func.isRequired
    };
    return HideDefaultDragPreviewDecorator;
  };
}